import React from 'react';
import { Section } from '../ui/Section';
import { CTAButton } from '../ui/CTAButton';
import { ShieldCheck, Download, Lock } from 'lucide-react';
export function FinalClose() {
  return <div className="bg-gradient-to-b from-[#FDF8F0] to-[#f4eadd] pb-16 pt-6" data-id="element-43">
      <Section data-id="element-44">
        {/* Layer 15: Final Close */}
        <div className="prose prose-lg prose-stone mx-auto text-[#2C1810] mb-8" data-id="element-45">
          <p data-id="element-46">Mira.</p>
          <p data-id="element-47">Sé que tienes dudas. Es normal.</p>
          <p data-id="element-48">
            Hemos sido entrenados a desconfiar de lo natural y confiar solo en
            lo que viene en caja con logo de farmacia.
          </p>
          <p data-id="element-49">
            Pero piensa en tu abuela. ¿Qué usaba ella cuando dolía algo? ¿Iba
            corriendo a la farmacia? No. Iba a su cocina.
          </p>
          <p className="font-bold" data-id="element-50">Y funcionaba.</p>
          <p data-id="element-51">
            No porque fuera magia. Porque sabía qué usar, cuánto usar y cuándo
            usarlo.
          </p>
          <p data-id="element-52">
            Eso es exactamente lo que este botiquín te da: El conocimiento
            ancestral + la precisión moderna de dosificación por peso.
          </p>
          <p className="text-xl font-bold text-center my-4 text-[#2D5016] bg-[#2D5016]/10 p-4 rounded-lg" data-id="element-53">
            Tu abuela tenía razón. Ahora tienes el manual completo.
          </p>

          <div className="mt-6 mb-8 relative" data-id="element-54">
            <div className="flex items-center gap-4 mb-4" data-id="element-55">
              <img src="https://cdn.magicpatterns.com/uploads/fVDFWEgb9yBsoFRrBPG9qe/autora.png" alt="Dra. Elena Ramírez" className="w-16 h-16 rounded-full object-cover object-top border-2 border-[#2D5016]/20 shadow-md" data-id="element-56" />
              <div data-id="element-57">
                <p className="font-serif italic text-lg" data-id="element-58">
                  Con fe en tu sanación,
                </p>
                <p className="text-2xl mt-1 text-[#C1440E] font-bold font-serif" data-id="element-59">
                  Dra. Elena Ramírez
                </p>
                <p className="text-sm text-gray-500" data-id="element-60">
                  Naturópata · Herbalista Certificada
                </p>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-[#D4A017] text-sm md:text-base shadow-sm mb-6" data-id="element-61">
            <p className="mb-3" data-id="element-62">
              <span className="font-bold text-[#C1440E] bg-[#C1440E]/10 px-1 rounded" data-id="element-63">
                P.S.
              </span>{' '}
              — Por $6.97 obtienes lo que generaciones enteras de abuelas
              tardaron décadas en perfeccionar. Dosificado. Organizado. Listo
              para usar hoy.
            </p>
            <p data-id="element-64">
              <span className="font-bold text-[#C1440E] bg-[#C1440E]/10 px-1 rounded" data-id="element-65">
                P.P.S.
              </span>{' '}
              — La garantía es total. Si en 30 días no ves resultados, te
              devolvemos cada centavo. El riesgo es cero. El alivio es tuyo.
            </p>
          </div>
        </div>

        <div id="final-cta" className="max-w-xl mx-auto" data-id="element-66">
          <CTAButton mainText="SÍ, QUIERO MI BOTIQUÍN COMPLETO — $6.97 USD" subText="Descarga instantánea · Acceso eterno · Garantía 30 días sin preguntas" onClick={() => {
          if (typeof (window as any).fbq === 'function') {
            ;
            (window as any).fbq('track', 'AddToCart', {
              content_name: 'Tu Botiquín Natural 30+',
              content_type: 'product',
              value: 6.97,
              currency: 'USD'
            });
          }
          window.open('https://www.simplementemejor.com/cart/51726218002712:1', '_blank');
        }} data-id="element-67" />

          {/* Final Trust Row */}
          <div className="flex justify-center gap-6 mt-6 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-68">
            <div className="flex flex-col items-center gap-1" data-id="element-69">
              <ShieldCheck className="w-6 h-6" data-id="element-70" />
              <span className="text-[10px] font-bold uppercase" data-id="element-71">Garantía</span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-72">
              <Lock className="w-6 h-6" data-id="element-73" />
              <span className="text-[10px] font-bold uppercase" data-id="element-74">Seguro</span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-75">
              <Download className="w-6 h-6" data-id="element-76" />
              <span className="text-[10px] font-bold uppercase" data-id="element-77">
                Instantáneo
              </span>
            </div>
          </div>
        </div>
      </Section>
    </div>;
}